import { Component, ElementRef, inject, OnInit, viewChildren } from '@angular/core';
import { RouterLink } from "@angular/router";
import { ActiveRoute } from '../active-route';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './faq.html',
  styleUrl: './faq.scss',
})
export class Faq implements OnInit{

   questionList = viewChildren<ElementRef>('question');
    activeRoute= inject(ActiveRoute);
  ngOnInit(): void {
    scroll(0,0)
  }
  openQuestion(n:number){
    
    this.questionList().forEach((question,index) => {
      question as ElementRef;
      if(index !==n) 

        question.nativeElement.open=false      
      
      
      
    });
    
  }
}
